import { PadType } from '@tencent/docs-mime-types';
import { getPathname } from '@tencent/ark-utils/lib/location';
import NoEditArkLoader from '@src/slide/application/no-edit/common/no-edit-ark-extensions';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { COMMON_LOADER_CONFIG } from './component-config';

enum SourceType {
    /** 模板商城 */
    TemplateMall = 'templatemall',
    /** vip 项目 */
    Vip = 'vip',
    /** desktop项目 */
    Desktop = 'desktop',
}

interface IShowOptions {
    // 品类类型（必传）
    padType: PadType | SourceType | string;
    domainId?: string;
    padId?: string;
    fileId?: string;
    docId?: string;
}

interface ICommonLoaderExtension {
    show: (options: IShowOptions) => void;
}

export async function showCommonLoader(): Promise<void> {
    const extension = await NoEditArkLoader.extensionService
        .getExtension(COMMON_LOADER_CONFIG.name) as ICommonLoaderExtension;
    const { domainId, padId, localPadId } = SlideDataServices.DocInfoManager() || {};
    const pathname = getPathname();
    const docId = pathname.slice(pathname.lastIndexOf('/') + 1); // 形如 'DUlFXTG1vZHlzbmZI'
    const options = {
        padType: PadType.Slide,
        domainId,
        docId,
        padId: padId || localPadId,
    };
    extension.show(options);
}
